import { VStack, Flex, Text, Button } from '@chakra-ui/react'
import { Link } from 'react-scroll'

import { motion } from 'framer-motion'

import { Product } from '../../../types'

const MotionButton = motion(Button)

interface Props {
  products: Pick<Product, 'id' | 'title'>[]
}

function PageHeader({ products }: Props): React.ReactElement {
  return (
    <VStack
      backgroundImage="url('/images/Landing/our-products/header.jpg')"
      spacing="10"
      sx={{
        py: 20,
        flexWrap: 'wrap',
        color: 'white',
        w: '100%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}
    >
      <Text
        as="h1"
        sx={{
          fontWeight: 'bold',
          fontSize: { base: '3xl', md: '6xl', 'lg+': '5xl' },
        }}
      >
        ผลิตภัณฑ์ของเรา
      </Text>
      <Flex
        sx={{
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        {products.map((product) => {
          return (
            <Link
              hashSpy
              smooth
              key={product.id}
              to={product.id}
              duration={800}
              offset={-56}
            >
              <MotionButton
                as="div"
                variant="outline"
                size="lg"
                whileHover={{
                  backgroundImage:
                    'linear-gradient(to top, rgba(36, 205, 203, 1), rgba(10, 222, 180, 1))',
                }}
                style={{
                  backgroundImage:
                    'linear-gradient(to top, rgba(36, 205, 203, 0), rgba(10, 222, 180, 0))',
                }}
                transition={{ type: 'spring' }}
                sx={{
                  m: 2,
                  w: '200px',
                  border: '2px solid',
                  color: 'white',
                  borderColor: 'currentColor',
                  borderRadius: '999px',
                  fontWeight: 'medium',
                }}
              >
                {product.title}
              </MotionButton>
            </Link>
          )
        })}
      </Flex>
    </VStack>
  )
}

export default PageHeader
